/* Tables sit in a white container with a hairline border and a quiet blue-grey header row
   (ADR 0019, ADR 0028). A wide table scrolls sideways inside it, never the page. */
.scroller {
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--paper);
}

/* Alone in a card: the card is the frame. It still scrolls sideways. */
.scroller[data-flat] {
  border: 0;
  border-radius: 0;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font: var(--t-body);
}

.column {
  height: var(--row-height-dense);
  padding: 0 var(--space-3);
  border-bottom: 1px solid var(--border);
  background: var(--canvas);
  color: var(--graphite);
  font: var(--t-small);
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
}

.cell {
  height: var(--row-height);
  padding: var(--space-2) var(--space-3);
  border-bottom: 1px solid var(--rule);
  vertical-align: middle;
}

.table[data-dense] .cell {
  height: var(--row-height-dense);
  padding-block: var(--space-1);
}

.column[data-numeric],
.cell[data-numeric] {
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
}

.row:last-child .cell,
.body[data-empty] td {
  border-bottom: 0;
}

/* The empty-state sentence sits where the first row would be. */
.body[data-empty] td {
  padding: var(--space-4) var(--space-3);
  color: var(--graphite);
}

.row {
  transition: background-color var(--dur) var(--ease);
}

/* Hover only happens on interactive rows (links, actions, selection). */
.row[data-hovered] {
  background: var(--brand-tint);
  cursor: pointer;
}

.row[data-pressed] {
  background: var(--brand-tint-strong);
}

/* The selected row: the strong primary tint (ADR 0028). */
.row[data-selected] {
  background: var(--brand-tint-strong);
  box-shadow: none;
}

.row[data-focus-visible],
.cell[data-focus-visible],
.column[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: -2px;
}
